import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { DocType, MimeType } from '@tencent/docs-mime-types';
import * as qs from 'querystringify';
import { getXsrfToken } from "../utils/cookie";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE } from "../model/drive-folder";
import { UserRole } from "../model/permission";
var baseUrl = "//".concat(location.hostname, "/cgi-bin/online_docs/");
var FOLDER_NEW = "".concat(baseUrl, "folder_new");

/**
 * 新建文件夹.
 */
export function createFolder(params) {
  return new CreateFolderRequest(params).send();
}
/**
 * 新建文件夹
 */
export var CreateFolderRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(CreateFolderRequest, _DriveRequest);
  var _super = _createSuper(CreateFolderRequest);
  function CreateFolderRequest() {
    _classCallCheck(this, CreateFolderRequest);
    return _super.apply(this, arguments);
  }
  _createClass(CreateFolderRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: FOLDER_NEW,
        data: qs.stringify({
          parent_folder_id: params.path,
          title: params.title,
          xsrf: getXsrfToken()
        })
      };
    }

    // eslint-disable-next-line max-lines-per-function
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (!response) {
        throw new DriveApiError({
          message: 'No response returned. Please capture the network packet to check the error.',
          name: 'CreateFolderError',
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      var retcode = response.retcode;
      if (retcode) return {
        retcode: retcode
      };
      var folder_info = response.folder_info;
      if (folder_info.collaboration_flag === 1) return {
        retcode: retcode,
        folder: {
          collaborationFlag: folder_info.collaboration_flag,
          createTs: folder_info.create_ts,
          title: folder_info.title,
          kind: COLLABORATION_SPACE_KIND,
          id: folder_info.folder_id,
          creator: {
            uid: folder_info.owner_uid,
            nick: ''
          },
          docType: DocType.Folder,
          iconUrl: '',
          lastBrowseTs: folder_info.create_ts,
          lastDeleteTs: 0,
          lastModifyTs: folder_info.create_ts,
          lastModifier: {
            uid: folder_info.owner_uid,
            nick: ''
          },
          mimeType: MimeType.CollaborationSpace,
          owner: {
            uid: folder_info.owner_uid,
            nick: ''
          },
          originParentId: null,
          parentId: folder_info.parent_folder_id,
          thirdAppId: null,
          isOwnedByMe: true,
          attribute: null,
          roleId: UserRole.Owner
        }
      };
      return {
        retcode: retcode,
        folder: {
          collaborationFlag: folder_info.collaboration_flag,
          createTs: folder_info.create_ts,
          title: folder_info.title,
          kind: DRIVE_FOLDER_KIND,
          id: folder_info.folder_id,
          creator: {
            uid: folder_info.owner_uid,
            nick: ''
          },
          docType: DocType.Folder,
          iconUrl: '',
          lastBrowseTs: folder_info.create_ts,
          lastDeleteTs: 0,
          lastModifyTs: folder_info.create_ts,
          lastModifier: {
            uid: folder_info.owner_uid,
            nick: ''
          },
          mimeType: MimeType.Folder,
          owner: {
            uid: folder_info.owner_uid,
            nick: ''
          },
          originParentId: null,
          parentId: folder_info.parent_folder_id,
          thirdAppId: null,
          isOwnedByMe: true,
          attribute: FOLDER_ATTRIBUTE
        }
      };
    }
  }]);
  return CreateFolderRequest;
}(DriveRequest);
//# sourceMappingURL=create-folder.js.map